import { useParams } from 'react-router-dom'
import { PageContentPreviousOrder } from '@restaurant/core'
import { useWebPreviousOrderPageViewModel } from '../viewmodels/pages/WebPreviousOrderPageViewModel'

export default function PreviousOrderPage() {
  const { orderId } = useParams<{ orderId: string }>()
  const viewModel = useWebPreviousOrderPageViewModel()

  if (!orderId) return null

  const pageProps = viewModel.getPageContentPreviousOrderProps(orderId)

  return (
    <PageContentPreviousOrder
      {...pageProps}
      testID="previous-order-page"
      accessibilityLabel="Previous order details"
    />
  )
}
